import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import useSeo from "../services/useSeo";

// Previously any unknown URL rendered <Home />, so Google could index unlimited
// junk paths as duplicates of the homepage. This page is noindex instead, and
// the server should return a real 404 status for unmatched routes.
export default function NotFound() {
  useSeo({
    title: "找不到頁面 | 琴語鋼琴網",
    description: "您要找的頁面不存在。",
    noindex: true,
  });

  return (
    <Container
      className="text-center d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "60vh", paddingTop: "30px", paddingBottom: "30px" }}
    >
      <h1 className="mb-3">404</h1>
      <h2 className="h4 mb-3">找不到這個頁面</h2>
      <p className="text-secondary mb-4">
        您要找的頁面可能已被移除、更名，或暫時無法使用。
      </p>
      <div className="d-flex flex-column flex-sm-row gap-2">
        <Button as={Link} to="/" variant="dark">
          回到首頁
        </Button>
        <Button as={Link} to="/search" variant="outline-secondary">
          搜尋琴譜
        </Button>
      </div>
    </Container>
  );
}
